import {Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckbox} from '@angular/material/checkbox';
import {TranslateModule} from '@ngx-translate/core';
import {MatInput, MatInputModule} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatButtonModule} from '@angular/material/button';
import {AuthService} from 'src/app/shared/services/auth.service';
import {Router} from '@angular/router';
import {ErrorInterface} from 'src/app/shared/interfaces/global';

@Component({
  selector: 'app-login-with-password',
  imports: [
    MatFormField,
    MatCheckbox,
    TranslateModule,
    MatInput,
    FormsModule,
    MatIconButton,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './login-with-password.component.html',
  styleUrl: './login-with-password.component.scss',
  standalone: true,
})
export class LoginWithPasswordComponent {
  constructor(
    private $auth: AuthService,
    private $router: Router,
  ) {
  }

  @Output() showConfirm: EventEmitter<string> = new EventEmitter();
  @Input() newPassword = false;

  login = '';
  password = '';
  confirmPassword = '';
  forgetPassword = false;
  hide = signal(true);
  // при входе по логину/паролю
  wrongPassword = false;
  // при восстановлении
  wrongLogin = false;
  errorMessage: ErrorInterface | null = null;

  short_session = false;

  clickEventPassword(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  forgetPasswordFunc() {
    this.errorMessage = null;
    this.forgetPassword = true;
  }

  routeToConfirm() {
    this.$auth.resetPassword(this.login).subscribe({
      next: (res) => {
        this.$auth.setTempToken(res.temporary_token);
        this.showConfirm.emit(this.login);
      },
      error: (res: { error: ErrorInterface }) => {
        this.wrongLogin = true;
        this.errorMessage = res.error;
      },
    });
  }

  loginWithPassword() {
    this.$auth.loginWithPassword(this.login, this.password, this.short_session).subscribe({
      next: (res) => {
        this.$auth.setToken(res.access_token, res.refresh_token);
        this.$router.navigate(['/answer']).then();
      },
      error: (res: { error: ErrorInterface }) => {
        this.errorMessage = res.error;
      },
    });
  }

  passwordResetComplete() {
    this.$auth.passwordResetComplete(this.password, this.short_session).subscribe({
      next: (res) => {
        this.$auth.setToken(res.access_token, res.refresh_token);
        this.$router.navigate(['/answer']).then();
      },
      error: (res: { error: ErrorInterface })=> {
        this.errorMessage = res.error;
      }
    });
  }
}
